import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocument } from '../requests';
import type { GetDocumentRequestType } from '../types';

export const useGetDocument = (
  documentId?: GetDocumentRequestType['documentId'],
) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.document, { documentId }],
    queryFn: () => getDocument({ documentId: documentId! }),
    enabled: !!documentId,
  });
